var map = {
	"./10C.png": 105,
	"./10D.png": 106,
	"./10H.png": 107,
	"./10S.png": 108,
	"./7C.png": 109,
	"./7D.png": 110,
	"./7H.png": 111,
	"./7S.png": 112,
	"./8C.png": 113,
	"./8D.png": 114,
	"./8H.png": 115,
	"./8S.png": 116,
	"./9C.png": 117,
	"./9D.png": 118,
	"./9H.png": 119,
	"./9S.png": 120,
	"./AC.png": 121,
	"./AD.png": 122,
	"./AH.png": 123,
	"./AS.png": 124,
	"./JC.png": 125,
	"./JD.png": 126,
	"./JH.png": 127,
	"./JS.png": 128,
	"./KC.png": 129,
	"./KD.png": 130,
	"./KH.png": 131,
	"./KS.png": 132,
	"./QC.png": 133,
	"./QD.png": 134,
	"./QH.png": 135,
	"./QS.png": 136,
	"./red_back.png": 59
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 47;